<template>
    <div class="popess">
        <div :style='style'>
            <div class="popess1" :style='popess1'></div>
        </div>
    </div>
</template>
<script>
// var that=this
export default {
  props: {
    /*编辑器的内容*/
    value: {
      type: Number,
      default: ()=>{ return null }
    },
    color:{
      type: Array,
      default: ()=>{ return null }
    },
    timeNum:{
      type: Number,
      default: ()=>{ return null }
    }
  },

  data() {
    return {
      content: this.value,
      ref: this.editorRef,
      style:null,
      popess1:null
    };
  },
  created(){
    this.init(this.value)
  },
  watch: {
    value(newVal){
      this.init(newVal)
    }
  },
  methods: {
    init(num){
      var style={}
      var popess1={}
      if(this.color){
        if(this.color.length==1){
          popess1.background=this.color
        }else{
          popess1.backgroundImage='linear-gradient(to right,'+this.color[0]+' , '+this.color[1]+')'
        }
        this.popess1=popess1
      }
      // if(this.timeNum){
      //   popess1.animation='mymove '+this.timeNum+'s normal forwards ease-in-out'
      // }
      this.popess1=popess1
      var length=Math.pow(10,num.toString().length-1) 
      var numStr =num/((parseInt(num/length)+1)*length)
      style.width=numStr*100+'%'
      this.style=style
    },
  }
};
</script> 

<style lang="scss"  scoped>
.popess{
    width: 45%;
    background: #323F62;
    border-radius: 15px;
    height: 15px;
    margin-left: 3%;
    overflow: hidden;
    div{
      border-radius: 15px;
    }
}
.popess1{
    background-image: linear-gradient(to right, #4635F3 , #4BF6EE);
    border-radius: 15px;
    height: 15px;
    animation:mymove 2s normal forwards ease-in-out;
}
@keyframes mymove{
    from {width: 0%;}
    to {width: 100%;}
}
</style>